<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="headTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainTitle"></div>
          <el-tabs class="elTabs" v-model="activeName" @tab-click="handleClick" v-if="initDatas">
            <el-tab-pane label="福利管理" name="0">
              <WelfareList></WelfareList>
            </el-tab-pane>
            <el-tab-pane label="招聘管理" name="1">
              <WelfareRecruitList></WelfareRecruitList>
            </el-tab-pane>
            <el-tab-pane label="返校报备" name="2">
              <CampusVisitList></CampusVisitList>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import WelfareList from '@/components/welfare/welfareList'
import WelfareRecruitList from '@/components/welfare/welfareRecruitList'
import CampusVisitList from '@/components/welfare/campusVisitList'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    WelfareList,
    WelfareRecruitList,
    CampusVisitList
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      headTitle: '',
      activeName: '0',
      initDatas: false
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.headTitle = this.$route.query.title
      // if (localStorage.getItem(this.$route.path)) this.activeName = localStorage.getItem(this.$route.path)
      this.initDatas = true
    },
    handleClick(tab, event) {
      // localStorage.setItem(this.$route.path, tab.name)
    }
  }
}
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -40px;
  margin-left: -20px;
  margin-right: -20px;
}
.elTabs {
  margin-top: -40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/welfare.vue